// extracted by mini-css-extract-plugin
export var chevronIcon = "_6a-2";
export var teamName = "_6a-1";
export var teamSwitcherButton = "_6a-0";